import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import {
  Card,
  HeadingText,
  StackLayout,
  TextAction,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';

type HighlightCardProps = {
  title: string;
  actionLink?: string;
  actionText?: string;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
};

export function HighlightCard({
  title,
  actionLink,
  actionText,
  children,
  onClick,
}: HighlightCardProps) {
  const { formatMessage } = useIntl();
  const displayText = actionText || formatMessage({ id: 'SEE_MORE' });
  const displayTextLabel = formatMessage(
    { id: 'X_ABOUT_X' },
    { left: displayText, right: title },
  );

  return (
    <Card.Elevated css={{ backgroundColor: '$surfaceCardSecondary' }}>
      <Card.Section>
        <StackLayout
          orientation="horizontal"
          horizontalAlignment="spaceBetween"
          verticalAlignment="center"
          css={{ marginBottom: '$one' }}
        >
          <HeadingText level="3" size="lg" id="test">
            {title}
          </HeadingText>
          <TextAction
            href={actionLink}
            onClick={onClick}
            css={{
              typography: '$buttonTwo',
            }}
          >
            <span aria-hidden>{displayText}</span>
            <VisuallyHidden>{displayTextLabel}</VisuallyHidden>
          </TextAction>
        </StackLayout>
        {children}
      </Card.Section>
    </Card.Elevated>
  );
}
